import { render, staticRenderFns } from "./EmailValidatedPage.vue?vue&type=template&id=af7fcf92&"
import script from "./EmailValidatedPage.vue?vue&type=script&lang=js&"
export * from "./EmailValidatedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports